import { ISortedPageRequest } from "common/interfaces/IPageRequest";

export interface IElectricityInvoice {
  id: number;
  invoiceNumber: number;
  dateIssued: string;
  dateDue: string;
  amountIncludingVat: number;
  amountExcludingVat: number;
  totalConsumption: number;
  totalProduction: number;
  consumptionAveragePrice: number;
  productionAveragePrice: number;
  fileName: string;
  customer: ElectricityInvoiceCustomer;
  agreement?: ElectricityInvoiceAgreement;
  invoiceGroup?: ElectricityInvoiceInvoiceGroup;
}

interface ElectricityInvoiceCustomer {
  id: number;
  name: string;
  eic: string;
}

interface ElectricityInvoiceAgreement {
  id: number;
  contractNumber: string;
}

interface ElectricityInvoiceInvoiceGroup {
  id: number;
  name: string;
}

export enum IElectricityInvoiceSortFields {
  ID = 'ID',
  INVOICE_NUMBER = 'INVOICE_NUMBER',
  DATE_ISSUED = 'DATE_ISSUED',
  DATE_DUE = 'DATE_DUE',
  AMOUNT_INCLUDING_VAT = 'AMOUNT_INCLUDING_VAT',
  AMOUNT_EXCLUDING_VAT = 'AMOUNT_EXCLUDING_VAT',
}

export type IElectricityInvoiceRequest = ISortedPageRequest<IElectricityInvoiceSortFields>;